"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategorySubjectGroupNotAllowedError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Error when adding subject group field to a category
 */
class CategorySubjectGroupNotAllowedError extends client_library_1.ExtendableError {
    constructor() {
        super(`Category cannot have a subject group`);
    }
}
exports.CategorySubjectGroupNotAllowedError = CategorySubjectGroupNotAllowedError;
//# sourceMappingURL=CategorySubjectGroupNotAllowedError.js.map